import { useContext } from 'react';
import { EntityOwnershipContextType } from 'contexts/entity-ownership/EntityOwnershipTypes';
import { EntityOwnershipContext } from 'contexts/entity-ownership/EntityOwnershipContext';

export function useEntityOwnershipContext() {
    return useContext<EntityOwnershipContextType | null>(
        EntityOwnershipContext
    );
}
